module.exports = __webpack_public_path__ + "media/images/how_it_works/subvention-8bc40ac024b5e2dbab7c5bd8536dbab7.svg";